import { Component, OnInit, Inject } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiDescs } from '../../api-client-module';
import { ApiDescDetail } from '../../api-client-module';
import { ProjectLanguage,ProjectLanguageClass } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { SelectVoiceFileDialogComponent } from 'src/app/select-voice-file-dialog/select-voice-file-dialog.component';
import { TranslateService } from '@ngx-translate/core';

export interface MultiDescDialogData {
  descs?: ApiDescs;
}

@Component({
  selector: 'app-multi-desc-dialog',
  templateUrl: './multi-desc-dialog.component.html',
  styleUrls: ['./multi-desc-dialog.component.css'],
  standalone: false,
})
export class MultiDescDialogComponent implements OnInit {

  //詳細情報×言語数
  descs!: ApiDescs;
  descsFormGroup!: FormGroup;
  descsArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;
  projectLanguageClasses!: Array<ProjectLanguageClass>; 

  voiceInfos: any[] = [];

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiDescDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiDescDialogData,
    public dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.projectLanguageClasses = this.projectLanguages.map((projectLanguage) => {
      return new ProjectLanguageClass(projectLanguage);
    });

    this.descs = this.data.descs!;
    if (!this.descs) {
      this.descs = {
        desc_details: []
      }
    }
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang!;
    this.createForm();
    this.descsArrayControl = this.descsFormGroup.get('descs') as FormArray;

    //プロジェクト基本言語が管理画面の言語と異なる場合、編集不可にする
    if ((this.currentLang == 'en' && this.projectBaseLang == 'ja') || (this.currentLang == 'ja' && this.projectBaseLang != 'ja')) {
      this.descsFormGroup.disable();
    }
  }

  //詳細フォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.descs.desc_details.length > 0 ? true : false;
    let isAutoAllVoice: boolean = this.descs.desc_details.length > 0 ? true : false;
    //不要と思われるのでコメントアウト
    // if(this.currentLang == 'en'){
    //   this.projectLanguages[0].lang_code = 'en';
    //   this.projectLanguages[0].lang_name = 'English';
    // }
    //不要と思われるのでコメントアウト
    for (const projectLanguage of this.projectLanguages) {
      let isCreated = false;
      for (const descDetail of this.descs.desc_details) {
        if (projectLanguage.lang_code === descDetail.lang_code) {
          if (!descDetail.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          if (!descDetail.auto_voice) {
            isAutoAllVoice = false;
          }
          let _descDetail = {};
          if (descDetail.voice_file_info) {
            _descDetail = {
              autoTrans: [descDetail.auto_trans, [Validators.required]],
              autoVoice: [descDetail.auto_voice, [Validators.required]],
              voiceFileName: [descDetail.voice_file_info!.file_name],
              voiceDownloadUrl: [descDetail.voice_file_info!.download_url]
            }
            this.voiceInfos.push({
              lang_code: descDetail.lang_code,
              voice_file_info: {
                download_url: descDetail.voice_file_info.download_url,
                file_name: descDetail.voice_file_info.file_name,
                file_path: descDetail.voice_file_info.file_path
              }
            });
          } else {
            _descDetail = {
              autoTrans: [descDetail.auto_trans, [Validators.required]],
              autoVoice: [descDetail.auto_voice, [Validators.required]],
              voiceFileName: [],
              voiceDownloadUrl: []
            }
            this.voiceInfos.push({
              lang_code: descDetail.lang_code,
              voice_file_info: {
                download_url: '',
                file_name: '',
                file_path: ''
              }
            });
          }
          const formGroup = this.formBuilder.group(_descDetail);
          if (index === 0) {
            formGroup.addControl('desc', new FormControl(descDetail.desc, [Validators.required]));
            formGroup.addControl('transDesc', new FormControl(descDetail.trans_desc, [Validators.required]));
            formGroup.addControl('voiceDesc', new FormControl(descDetail.voice_desc, [Validators.required]));
          } else {
            formGroup.addControl('desc', new FormControl(descDetail.desc));
            formGroup.addControl('voiceDesc', new FormControl(descDetail.voice_desc ? descDetail.voice_desc : descDetail.desc));
          }
          arrayControl.push(formGroup);
          isCreated = true;
          break;
        }
      }
      if (!isCreated) {
        // 新規言語分
        const formGroup = this.formBuilder.group(
          {
            autoTrans: [false, [Validators.required]],
            autoVoice: [false, [Validators.required]],
            voiceFileName: [''],
            voiceDownloadUrl: ['']
          }
        );
        if (index === 0) {
          formGroup.addControl('desc', new FormControl('', [Validators.required]));
          formGroup.addControl('transDesc', new FormControl('', [Validators.required]));
          formGroup.addControl('voiceDesc', new FormControl('', [Validators.required]));
        } else {
          formGroup.addControl('desc', new FormControl(''));
          formGroup.addControl('voiceDesc', new FormControl(''));
        }
        arrayControl.push(formGroup);
        this.voiceInfos.push({
          lang_code: projectLanguage.lang_code,
          voice_file_info: {
            download_url: '',
            file_name: '',
            file_path: ''
          }
        });
      }
      index++;
    }
    this.descsFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans, [Validators.required]],
        autoAllVoice: [isAutoAllVoice, [Validators.required]],
        descs: arrayControl
      }
    );
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.descsFormGroup.get('autoAllTrans')!.value;
    for (const desc of this.descsArrayControl.controls) {
      desc.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.descsArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const desc of this.descsArrayControl.controls) {
      if (!desc.get('autoTrans')!.value  && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.descsFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

  //全言語音声作成
  onChangeAutoAllVoice(): void {
    const isAutoAllVoice = this.descsFormGroup.get('autoAllVoice')!.value;
    for (const desc of this.descsArrayControl.controls) {
      desc.get('autoVoice')!.setValue(isAutoAllVoice);
    }
  }

  //言語別音声作成
  onChangeAutoVoice(): void {
    let isAutoAllVoice: boolean = true;
    for (const desc of this.descsArrayControl.controls) {
      if (!desc.get('autoVoice')!.value) {
        isAutoAllVoice = false;
        break;
      }
    }
    this.descsFormGroup.get('autoAllVoice')!.setValue(isAutoAllVoice);
  }

  //更新ボタン
  addDescs(): void {
    const descDetails:Array<ApiDescDetail> = [];
    let index: number = 0;
    //不要と思われるのでコメントアウト
    // if(this.currentLang == 'en'){
    //   this.projectLanguages[0].lang_code = 'ja';
    //   this.projectLanguages[0].lang_name = 'English';
    // }
    //不要と思われるのでコメントアウト
    for (const desc of this.descsArrayControl.controls) {
      const descDetail: ApiDescDetail = {
        auto_trans: desc.get('autoTrans')!.value,
        auto_voice: desc.get('autoVoice')!.value,
        lang_code: this.projectLanguages[index].lang_code,
        desc: desc.get('desc')!.value,
        trans_desc: '',
        voice_desc: ''
      }
      for (const value of this.voiceInfos) {
        if (this.projectLanguages[index].lang_code === value.lang_code) {
          descDetail.voice_file_info = value.voice_file_info;
        }
      }
      if (index === 0) {
        descDetail.trans_desc = desc.get('transDesc')!.value;
      }
      descDetail.voice_desc = desc.get('voiceDesc')!.value;
      descDetails.push(descDetail);
      index++;
    }
    this.descs.desc_details = descDetails;
    const result: ApiDescs = {
      desc_details: this.descs.desc_details
    }
    this.dialogRef.close(result);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  openSelectVoiceFileDialog(i: number): void {
    const dialogRef = this.dialog.open(SelectVoiceFileDialogComponent, {
      width: '80%',
      height: '90%',
      disableClose: true,
      data: { uploadedFile: null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.voiceInfos[i].voice_file_info = {
          download_url: result.download_url,
          file_name: result.file_name,
          file_path: result.file_path
        }
        this.descsArrayControl.controls[i].get('voiceFileName')?.setValue(result.file_name);
        this.descsArrayControl.controls[i].get('voiceDownloadUrl')?.setValue(result.download_url);
      }
    });
  }

  deleteVoiceFile(i: number): void {
    this.voiceInfos[i].voice_file_info = {
      download_url: '',
      file_name: '',
      file_path: ''
    }
    this.descsArrayControl.controls[i].get('voiceFileName')?.setValue('');
    this.descsArrayControl.controls[i].get('voiceDownloadUrl')?.setValue('');
  }

}
